import {GET, POST} from '../index'

// 获取视频列表
export const getList = (data) => {
  return GET('/video/list', data)
}
// 添加视频
export const addVideo = (data) => {
  return POST('/video/add', data)
}
// 更改视频排序
export const storeSort = (data) => {
  return POST('/video/change/sort', data)
}
// 更改视频状态
export const changeStatus = (data) => {
  return POST('/video/change/status', data)
}

// 删除视频
export const delVideo = (data) => {
  return POST('/video/del', data)
}

// 更新视频
export const updateVideo = (data) => {
  return POST('/video/update', data)
}

// 获取腾讯云sdk签名
export const getTencentSign = () => {
  return GET('/video/tencent/sign')
}



// WEBPACK FOOTER //
// ./src/api/video/index.js